// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledHijackTopbar = styled('div')(
  () => css`
    .hijack-topbar {
      height: 64px;
      background: #f16063;
      color: #fff;
      font-weight: 800;
      font-size: 1.5rem;
      font-style: normal;
      display: flex;
      .sidebar {
        width: 80px;
      }
      .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 33px;
        height: 100%;
        width: 100%;
        .info-icon {
          font-weight: 500;
          margin-left: 25px;
        }
        .exit-button {
          background-color: #ffffff;
          padding: 8px 36px !important;
          color: #f16063;
        }
      }
      &.is-sidebar-menu-expended {
        .sidebar {
          width: 258px;
          min-width: 258px;
        }
      }
    }
  `
);
